import BaseLayout from '@/components/BaseLayout.vue';
import ProductCountModal from '@/components/NewPromotions/ProductLager/ProductCountModal.vue';
import Product from './Product/Product.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data: function () {
        return {
            modalShown: false,
            clickedProduct: {},
            searchQuery: null,
            category: 0,
        }
    },

    components: {
        BaseLayout,
        ProductCountModal,
        Product,
    },

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),

        resultQuery() {
            if (this.promotion.activePromotion) {

                if (this.searchQuery || this.category) {
                    return this.promotion.activePromotion.products.filter((item) => {
                        let search = true;
                        if (this.searchQuery) {
                            search = this.searchQuery
                                .toLowerCase()
                                .split(' ')
                                .every(v => item.name.toLowerCase().includes(v))
                        }

                        if (this.category > 0) {
                            return search && item.category.id === this.category;
                        }

                        return search;
                    })
                }

                return this.promotion.activePromotion.products;
            }

        },

        categories() {
            if (this.promotion.activePromotion) {
                let arrayCategories = this.promotion.activePromotion.products.map((product) => {
                    return product.category;
                })
                // This will find duplicates if exist and remove them
                return arrayCategories.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
            }
        },
    },

    methods: {
        showModal(value) {
            const product = this.promotion.activePromotion.products.filter(obj => {
                return obj.bnr === value
            })
            // Ako se ne pronadje proizvod, vrati neku gresku
            if(!product) {
                return;
            }

            this.clickedProduct = product[0];
            this.modalShown = true;
        },
    },
}